// eslint-disable-next-line import/prefer-default-export
export const isItemPreview = ({ metadata }) => 'draft' === metadata.status;
